import { ChangeDetectionStrategy, Component, NgZone } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

interface TooltipData {
  cellContent: string;
  tooltipContent: string;
}

interface CellRendererParams {
  class: string;
  containerClass: string;
  container: string;
  placement: string;
  trigger: string;
}

@Component({
  selector: 'vle-tooltip-cell-renderer',
  templateUrl: './tooltip-cell-renderer.component.html',
  styleUrls: ['tooltip-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipCellRendererComponent implements ICellRendererAngularComp {
  data: TooltipData;
  cellRendererParams: CellRendererParams;
  trigger: CellRendererParams['trigger'];

  constructor(private ngZone: NgZone) {}

  agInit(params: ICellRendererParams): void {
    this.setContents(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setContents(params);

    return false;
  }

  setContents({ value, colDef }: ICellRendererParams): void {
    this.data = value;
    this.cellRendererParams = colDef?.cellRendererParams;
    this.trigger = colDef?.cellRendererParams?.trigger ?? 'hover';
  }

  onShown(_: MouseEvent): void {
    this.ngZone.run(() => {
      setTimeout(() => {
        // https://veloce.atlassian.net/browse/CRQ-884
        // https://veloce.atlassian.net/browse/CRQ-996
        // this hack is needed to run extra change detection
        // because when component is used in runtime it doesn't always open
      }, 50);
    });
  }
}
